import { DropDownFilterProps, DropDownFilter } from 'framework/list';
import { FilterCondition } from 'framework/types';
import React from 'react';
import { Dropdown, DropdownOption } from 'framework/form';

const ListContainsFilter = ({
  dropdownLabel,
  options,
  conditionType = FilterCondition.OR,
  ...props
}: Omit<DropDownFilterProps, 'children'> & {
  options?: DropdownOption[];
  dropdownLabel?: string;
}) => {
  return (
    <DropDownFilter {...props} conditionType={conditionType}>
      <Dropdown options={options} label={dropdownLabel} source={props.source} />
    </DropDownFilter>
  );
};

export default ListContainsFilter;
